// extracted by mini-css-extract-plugin
export default {"preview":"preview---EzM2A","wrap":"wrap---GQjkT"};